import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';

const getSearchProviderData = async ({
  limit = 3,
  sp_category_id,
}) => {
  const params = {
    limit,
    service_provider_category_id: sp_category_id,
  };

  return await Query(`
  {
    search_service_providers (${jsonToInputParams(params)}) {
      results {
        agency_name
        id
        website
        email
        title
        phone_number
        addresses {
          line_1
          city
          state
          coordinates
        }
        service_provider_category {
          id
          name
        }
      }
    }
  }
    `);
};

export default getSearchProviderData;
